export const getNameInitials = (name) => {
  if (!name || !name.length) return "";
  const nameSplit = name.split(" ");
  const initials =
    nameSplit.length == 1
      ? nameSplit[0].substring(0, 2)
      : nameSplit[0][0] + nameSplit[1][0];
  return initials.toUpperCase();
};
